export const setCookie = (name, value) => {
    let d = new Date();
    d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
    let expires = 'expires=' + d.toUTCString();
    document.cookie = name + '=' + value + ';' + expires + ';path=/';
};

export const getCookies = () => {
    let cookies;
    let cookiesArray = [];

    cookies = decodeURIComponent(document.cookie);
    cookies = cookies.split(';');

    cookies.forEach(function (elt) {
        cookiesArray[elt.split('=')[0].replace(/^\s+|\s+$/g, '')] =
            elt.split('=')[1];
    });
    return cookiesArray;
};

export const getDatesCookies = () => {
    const cookies = getCookies();

    return {
        startDate: cookies['startDate'],
        endDate: cookies['endDate'],
        startDateToCompare: cookies['startDateToCompare'],
        endDateToCompare: cookies['endDateToCompare'],
        period: cookies['period'],
        periodToCompare: cookies['periodToCompare'],
    };
};
